import DonationModal from "./DonationModal";

interface DonationProps {
    url: string;
}

const Donation = ({ url }: DonationProps) => {
    return (
        <>
            <DonationModal URL={url} />

        </>


    );
}
export default Donation;